import { Outlet, Link, useLocation } from 'react-router-dom';

export function LandingLayout() {
  const location = useLocation();
  
  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="min-h-screen bg-off-white">
      {/* Header */}
      <header className="navbar-glass sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="text-xl font-bold text-olive-900 hover:text-olive-700 transition-colors">
              Sareto
            </Link>
            <nav className="flex items-center gap-6">
              <Link
                to="/"
                className={`text-sm font-medium transition-colors ${
                  isActive('/') 
                    ? 'text-olive-800' 
                    : 'text-gray-600 hover:text-olive-700'
                }`}
              >
                Home
              </Link>
              <Link
                to="/resources"
                className={`text-sm font-medium transition-colors ${
                  isActive('/resources') 
                    ? 'text-olive-800' 
                    : 'text-gray-600 hover:text-olive-700'
                }`}
              >
                Free Guide
              </Link>
              <Link
                to="/waitlist"
                className="btn-primary text-sm font-medium px-4 py-2 rounded-lg text-white"
              >
                Join Waitlist
              </Link>
            </nav>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main>
        <Outlet />
      </main>
    </div>
  );
}
